import React from 'react';
import FamilyCard from './FamilyCard';

const body = [
  'Dr. Amara Osei organized the Medical Consciousness Collective in 2093 — the initiative that <strong class="text-white">eliminated cancer, cardiovascular disease, and neurodegeneration</strong> within fifteen years.',
  'Her descendants became the biologists of the outer solar system: present at the discovery of life on Europa, leading the Enceladus Preservation Project, protecting the dancers of the dying moon across generations.',
  'The Osei-Okonkwo lineage represents the book\'s central moral arc: a family that began by healing human bodies and evolved, across centuries, into the <strong class="text-white">guardians of non-human life</strong>. Their recurring presence throughout the chronicle is the story of what humans become when they choose, consistently, to protect rather than exploit.',
];

const FamilyOsei = () => (
  <FamilyCard
    id="family-2"
    accentColor="text-green-400"
    dotColor="bg-green-400"
    borderColor="border-green-500/20"
    bgGlow="bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-green-900/10 via-transparent to-transparent"
    tag="The Healers & Guardians · Earth / Venus / Enceladus"
    name="The Osei-Okonkwos"
    origin="Earth · Venus · Enceladus"
    role="The Healers"
    body={body}
    quote="We are a species that saves dancers."
    quoteSource="Dr. Chiamaka Okonkwo-Matsumoto, Director of the Enceladus Preservation Project, 2501"
  />
);

export default FamilyOsei;